import graphql from "babel-plugin-relay/macro";

export const ACCOUNT_CODE_FRAGMENT = graphql`
    fragment accountCodeColumn_Fragment on User {
        extension(userExtensionKind: InfectopharmUserExtension) {
            ... on InfectopharmUserExtension {
                accountCode
            }
        }
    }
`;
